import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { AppRoutingModule } from "./app-routing.module";
import { AuthInterceptor } from "./core/auth.interceptor";
import { SecurityModule, SecurityModuleConfig } from "./Arquetipo-Security/lib/components/keycloak/security.module";
import { GestionTokenService } from "./Arquetipo-Security/lib/components/keycloak/fomento.gestionToken/gestionToken.service";
import { environment } from "./env/environment";

// Configuracion especifica de Keycloak para este proyecto
const keycloakConfig: SecurityModuleConfig = {
  config: environment.keycloak,
  initOptions: {
    onLoad: 'check-sso',
    checkLoginIframe: false,
    useNonce: false
  },
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    SecurityModule.forRoot(keycloakConfig),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    GestionTokenService,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
